window.createGridLines = function (canvas, max_canvas_width, grid, outline_width, gridWidth, gridHeight)
{
    // --- Adjust outline/header thickness for numbering ---
    var headerCellSize = 40; // px, enough for badge

    // Clear any existing grid badges to prevent duplication
    var objects = canvas.getObjects();
    for (var i = objects.length - 1; i >= 0; i--) {
        if (objects[i]._isGridBadge) {
            canvas.remove(objects[i]);
        }
    }

    // Responsive badge sizing - use pills until they would overlap, then switch to circles
    var pillWidth = 32;
    var pillHeight = 24;
    var pillMargin = 4; // Minimum margin to prevent overlap

    // Check if pill would fit without overlapping into adjacent cells
    var pillWouldFit = (grid >= (pillWidth + pillMargin * 2));
    var badgeWidth, badgeHeight, badgeFontSize, badgeOffset;



    if (pillWouldFit) {
        // Use pill shape when it fits without overlapping
        badgeWidth = pillWidth;
        badgeHeight = pillHeight;
        badgeFontSize = 15;
        badgeOffset = (headerCellSize - badgeHeight) / 2;

    } else {
        // Use circular badges when pills would overlap
        badgeWidth = Math.max(20, Math.min(grid * 0.75, grid - 6)); // Responsive width with margin
        badgeHeight = badgeWidth; // Make it circular
        badgeFontSize = Math.max(10, Math.min(badgeWidth * 0.45, 18)); // Responsive font size
        badgeOffset = (headerCellSize - badgeHeight) / 2;

    }

    var badgeColor = 'rgba(159, 132, 59, 0.13)';
    var badgeStroke = 'rgba(159, 132, 59, 0.18)';
    var badgeTextColor = '#7a6a3a';
    var badgeShadow = new fabric.Shadow({ color: 'rgba(0,0,0,0.07)', blur: 4, offsetX: 0, offsetY: 1 });
    var gridLineColor = 'rgba(108, 117, 125, 0.08)';
    var gridLineDash = [4, 6];
    var outlineLineColor = 'rgba(159, 132, 59, 0.35)';
    var outlineLineWidth = 3;

    // Calculate total canvas size - ensure we use exact grid dimensions
    var width_ct = Math.floor(gridWidth / grid);
    var height_ct = Math.floor(gridHeight / grid);

    // Ensure we don't create extra badges due to rounding errors
    if (width_ct * grid > gridWidth) {
        width_ct = Math.floor(gridWidth / grid);
    }
    if (height_ct * grid > gridHeight) {
        height_ct = Math.floor(gridHeight / grid);
    }

    // Ensure minimum valid dimensions
    if (width_ct <= 0) width_ct = 1;
    if (height_ct <= 0) height_ct = 1;

    // The grid dimensions should represent the actual grid area (excluding headers)
    // The canvas needs to be sized to accommodate the grid plus header space
    var canvasWidth = gridWidth + headerCellSize;
    var canvasHeight = gridHeight + headerCellSize;

    // Set canvas dimensions
    canvas.setWidth(canvasWidth);
    canvas.setHeight(canvasHeight);

    // Helper for responsive pill/circular badge style, centered in header cell
    function addModernNumbering(text, left, top, isCol) {
        var bg;

        if (pillWouldFit) {
            // Use pill-shaped badges when they fit without overlapping

            bg = new fabric.Rect({
                left: left + (isCol ? grid/2 - badgeWidth/2 : (headerCellSize-badgeWidth)/2),
                top: top + (isCol ? badgeOffset : grid/2 - badgeHeight/2),
                width: badgeWidth,
                height: badgeHeight,
                rx: badgeHeight/2,
                ry: badgeHeight/2,
                fill: badgeColor,
                stroke: badgeStroke,
                strokeWidth: 1,
                selectable: false,
                evented: false,
                hasControls: false,
                hasBorders: false,
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true,
                shadow: badgeShadow,
                _isGridBadge: true,  // Mark as grid badge to prevent duplication
                keep_object: true  // Prevent deletion when clearing form
            });
        } else {
            // Use circular badges when pills would overlap

            bg = new fabric.Circle({
                left: left + (isCol ? grid/2 - badgeWidth/2 : (headerCellSize-badgeWidth)/2),
                top: top + (isCol ? badgeOffset : grid/2 - badgeHeight/2),
                radius: badgeWidth/2,
                fill: badgeColor,
                stroke: badgeStroke,
                strokeWidth: 1,
                selectable: false,
                evented: false,
                hasControls: false,
                hasBorders: false,
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true,
                shadow: badgeShadow,
                _isGridBadge: true,  // Mark as grid badge to prevent duplication
                keep_object: true  // Prevent deletion when clearing form
            });
        }

        var label = new fabric.Text(text, {
            left: left + (isCol ? grid/2 : headerCellSize/2),
            top: top + (isCol ? headerCellSize/2 : grid/2),
            fontSize: badgeFontSize,
            fontFamily: 'Work Sans, Arial, sans-serif',
            fill: badgeTextColor,
            fontWeight: 'bold',
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            hasControls: false,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            lockRotation: true,
            lockScalingX: true,
            lockScalingY: true,
            _isGridBadge: true,  // Mark as grid badge to prevent duplication
            keep_object: true  // Prevent deletion when clearing form
        });
        canvas.add(bg);
        canvas.add(label);
    }

    // --- Draw thick outline/header lines ---
    canvas.add(new fabric.Rect({
        left: 0,
        top: 0,
        width: canvasWidth,
        height: headerCellSize,
        fill: '#fff',
        selectable: false,
        evented: false
    }));
    canvas.add(new fabric.Rect({
        left: 0,
        top: 0,
        width: headerCellSize,
        height: canvasHeight,
        fill: '#fff',
        selectable: false,
        evented: false
    }));
    canvas.add(new fabric.Line([headerCellSize, headerCellSize, canvasWidth, headerCellSize], {
        stroke: outlineLineColor,
        strokeWidth: outlineLineWidth,
        selectable: false,
        evented: false
    }));
    canvas.add(new fabric.Line([headerCellSize, headerCellSize, headerCellSize, canvasHeight], {
        stroke: outlineLineColor,
        strokeWidth: outlineLineWidth,
        selectable: false,
        evented: false
    }));

    // --- Draw column numbers (top header row) ---
    for(var x=0;x<width_ct;x++) {
        var show_col_name = (x+1).toString();
        var left_size = headerCellSize + (grid * x);
        addModernNumbering(show_col_name, left_size, 0, true);
        // Grid line (vertical)
        var line = new fabric.Line([
            left_size,
            headerCellSize,
            left_size,
            canvasHeight
        ], {
            type:'line',
            stroke: gridLineColor,
            strokeWidth: 1,
            selectable: false,
            evented: false,
            strokeDashArray: gridLineDash
        });
        canvas.add(line);
    }
    // Add last vertical grid line at the end
    var last_vline = new fabric.Line([
        headerCellSize + (grid * width_ct),
        headerCellSize,
        headerCellSize + (grid * width_ct),
        canvasHeight
    ], {
        type:'line',
        stroke: gridLineColor,
        strokeWidth: 1,
        selectable: false,
        evented: false,
        strokeDashArray: gridLineDash
    });
    canvas.add(last_vline);

    // --- Draw row letters (left header col) ---
    for(var y=0;y<height_ct;y++) {
        // Use proper base-26 conversion for row letters (A, B, C, ..., Z, AA, AB, AC, ...)
        var show_row_name = numberToLetter(y);
        var top_size = headerCellSize + (grid * y);
        addModernNumbering(show_row_name, 0, top_size, false);
        // Grid line (horizontal)
        var line = new fabric.Line([
            headerCellSize,
            top_size,
            canvasWidth,
            top_size
        ], {
            type: 'line',
            stroke: gridLineColor,
            strokeWidth: 1,
            selectable: false,
            evented: false,
            strokeDashArray: gridLineDash
        });
        canvas.add(line);
    }
    // Add last horizontal grid line at the end
    var last_hline = new fabric.Line([
        headerCellSize,
        headerCellSize + (grid * height_ct),
        canvasWidth,
        headerCellSize + (grid * height_ct)
    ], {
        type: 'line',
        stroke: gridLineColor,
        strokeWidth: 1,
        selectable: false,
        evented: false,
        strokeDashArray: gridLineDash
    });
    canvas.add(last_hline);
}

/**
 * Convert number to letter (0=A, 1=B, 26=AA, 27=AB, etc.)
 */
window.numberToLetter = function (number) {
    let result = '';
    let n = number;

    while (n >= 0) {
        result = String.fromCharCode(65 + (n % 26)) + result;
        n = Math.floor(n / 26) - 1;
        if (n < 0) break;
    }

    return result;
}

window.createId = function () {
    var min = 99;
    var max = 9999999;
    var random = Math.floor(Math.random() * (max - min + 1)) + min;
    return String(new Date().getTime() + random);
}

window.addSeatObject = function (loaded_from_dbase, x_location, y_location, box_size, seat_color, locked = false, layout_id = null, person_name = null, floor_plan_seat_id = null, selectable = true) {
    // Check if there's already a seat at this position (prevent duplicates)
    if (typeof canvas !== 'undefined' && canvas) {
        var existingSeat = canvas.getObjects().find(function(obj) {
            return (obj.type === 'circle' || (obj.type === 'group' && obj.personName)) &&
                   Math.abs(obj.left - x_location) < box_size/2 &&
                   Math.abs(obj.top - y_location) < box_size/2;
        });

        if (existingSeat) {
            return existingSeat; // Return existing seat instead of creating new one
        }
    }

    if (layout_id === null)
    {
        layout_id = createId();
    }
    var radius_size = box_size / 2; // Perfect half-size for centering
    // Always apply grid alignment for consistency across all views
    if (typeof applySeatGridAlignment === 'function') {
        // Create a temporary object to calculate aligned position
        var tempObj = {
            left: x_location,
            top: y_location,
            set: function(props) {
                this.left = props.left;
                this.top = props.top;
                this.radius = props.radius;
            }
        };
        var aligned = applySeatGridAlignment(tempObj, x_location, y_location);
        x_location = aligned.left;
        y_location = aligned.top;
        radius_size = aligned.radius;
    } else if (!loaded_from_dbase) {
        // Fallback to original logic if alignment function not available (only for new seats)
        var gridX = Math.round((x_location - 40) / box_size); // 40 is headerCellSize
        var gridY = Math.round((y_location - 40) / box_size);

        // Ensure grid coordinates are within bounds
        gridX = Math.max(0, gridX);
        gridY = Math.max(0, gridY);

        // Calculate exact center position for perfect grid alignment
        var centerX = 40 + (gridX * box_size) + (box_size / 2);
        var centerY = 40 + (gridY * box_size) + (box_size / 2);

        // Calculate top-left position for the seat circle
        x_location = centerX - radius_size;
        y_location = centerY - radius_size;
    }
    if(locked)
    {
        lock_move_x = true;
        lock_move_y = true;
    }else{
        lock_move_x = false;
        lock_move_y = false;
    }
    // Only add the name label if window.showMemberNames is true
    if(person_name !== null && typeof window.showMemberNames !== 'undefined' && window.showMemberNames) {
        var circle = new fabric.Circle({
            left: radius_size, // Position circle at radius distance from left edge
            top: radius_size,  // Position circle at radius distance from top edge
            radius: radius_size,
            height: box_size,
            width: box_size,
            fill: seat_color,
            type: 'circle',
            stroke: '',
            originX: 'center', // Center origin for proper positioning
            originY: 'center', // Center origin for proper positioning
            text_val: person_name,
            // Add modern styling
            rx: 2, // Slight border radius for modern look
            ry: 2
        });

        // Improved text positioning and sizing logic
        var text = createOptimizedSeatLabel(person_name, box_size, radius_size);

        // Check for overlapping labels with adjacent seats
        var adjustedText = adjustTextForOverlap(text, x_location, y_location, box_size);
        if (adjustedText) {
            text = adjustedText;
        }

        var group = new fabric.Group([circle, text], {
            hasControls: false,
            lockMovementX: lock_move_x,
            lockMovementY: lock_move_y,
            lockScalingX: true, // Prevent resizing in X
            lockScalingY: true, // Prevent resizing in Y
            selectable: selectable,
            // Position the group at the same position as non-assigned seats
            left: x_location,
            top: y_location,
            width: box_size,
            height: box_size,
            originX: 'left',
            originY: 'top',
            // Add modern styling for groups
            shadow: new fabric.Shadow({
                color: 'rgba(0,0,0,0.1)',
                blur: 4,
                offsetX: 2,
                offsetY: 2
            })
        });
        group.personName = person_name;
        group.id = layout_id;
        group.seat_id = floor_plan_seat_id;
        canvas.add(group);
        return group;
    }else{
        var circle = new fabric.Circle({
            left: x_location,
            top: y_location,
            radius: radius_size,
            height: box_size,
            width: box_size,
            fill: seat_color,
            type: 'circle',
            stroke:'',
            originX: 'left',
            originY: 'top',
            id: layout_id,
            hasControls: false,
            lockMovementX: lock_move_x,
            lockMovementY: lock_move_y,
            lockScalingX: true, // Prevent resizing in X
            lockScalingY: true, // Prevent resizing in Y
            selectable: selectable,
            // Add modern styling
            shadow: new fabric.Shadow({
                color: 'rgba(0,0,0,0.1)',
                blur: 4,
                offsetX: 2,
                offsetY: 2
            }),
            rx: 2, // Slight border radius for modern look
            ry: 2
        });
        canvas.add(circle);
        return circle;
    }
}

window.addStructureObject = function (box_size, furniture_color, x_location = "", y_location = "", width_size = "", height_size = "", locked = false, id = null) {
    // Check if there's already a furnishing at this position (prevent duplicates)
    if (typeof canvas !== 'undefined' && canvas) {
        var existingFurniture = canvas.getObjects().find(function(obj) {
            return obj.type === 'rectangle' && typeof obj.text === 'undefined' &&
                   Math.abs(obj.left - x_location) < box_size/2 &&
                   Math.abs(obj.top - y_location) < box_size/2;
        });

        if (existingFurniture) {
            return existingFurniture; // Return existing furniture instead of creating new one
        }
    }

    // Margin to keep furnishings inside grid borders
    var FURNITURE_MARGIN = 3; // px, increased for better spacing

    if (id === null) {
        id = createId();
    }

    if(x_location === "") {
        x_location = box_size;
    }
    if(y_location === "") {
        y_location = box_size;
    }
    if(width_size === "")
    {
        width_size = box_size * 2;
    }
    if(height_size === "")
    {
        height_size = box_size * 2;
    }

    // Always apply grid alignment for consistency across all views
    if (typeof applyFurnitureGridAlignment === 'function') {
        // Create a temporary object to calculate aligned position and size
        var tempObj = {
            left: x_location,
            top: y_location,
            width: width_size,
            height: height_size,
            set: function(props) {
                this.left = props.left;
                this.top = props.top;
                this.width = props.width;
                this.height = props.height;
            }
        };
        var aligned = applyFurnitureGridAlignment(tempObj, x_location, y_location, width_size, height_size);
        x_location = aligned.left;
        y_location = aligned.top;
        width_size = aligned.width;
        height_size = aligned.height;
    } else {
        // Fallback to original logic if alignment function not available
        var gridX = Math.round((x_location - 40) / box_size); // 40 is headerCellSize
        var gridY = Math.round((y_location - 40) / box_size);

        // Ensure grid coordinates are within bounds
        gridX = Math.max(0, gridX);
        gridY = Math.max(0, gridY);

        // Calculate exact pixel position for perfect grid alignment
        x_location = 40 + (gridX * box_size) + FURNITURE_MARGIN/2;
        y_location = 40 + (gridY * box_size) + FURNITURE_MARGIN/2;

        // Calculate width/height in grid cells and snap to grid
        var widthCells = Math.max(1, Math.round(width_size / box_size));
        var heightCells = Math.max(1, Math.round(height_size / box_size));

        // Calculate exact dimensions based on grid cells
        width_size = (widthCells * box_size) - FURNITURE_MARGIN;
        height_size = (heightCells * box_size) - FURNITURE_MARGIN;
    }

    if(locked)
    {
        lock_move_x = true;
        lock_move_y = true;
        selectable = false;
    }else{
        lock_move_x = false;
        lock_move_y = false;
        selectable = true;
    }

    var rect = new fabric.Rect({
        left: x_location,
        top: y_location,
        width: width_size,
        height: height_size,
        type: 'rectangle',
        fill: furniture_color,
        stroke:'',
        originX: 'left',
        originY: 'top',
        id: id,
        hasRotatingPoint: false,
        hasControls: true,
        lockRotation: true,     //lock it so it can't rotate
        lockMovementX: lock_move_x,
        lockMovementY: lock_move_y,
        lockScalingFlip: true,  // Prevent flipping during scaling
        selectable: selectable,
        // Add modern styling
        rx: 6, // Border radius for modern look
        ry: 6,
        shadow: new fabric.Shadow({
            color: 'rgba(0,0,0,0.1)',
            blur: 6,
            offsetX: 3,
            offsetY: 3
        })
    });

    // Set minimum scale limit to prevent furnishings from being resized smaller than one grid cell
    var minSize = box_size;
    rect.minScaleLimit = Math.min(minSize / rect.width, minSize / rect.height);

    canvas.add(rect);
    //make sure it is 1 layer down so that textbox will show on top
    canvas.sendBackwards(rect);

    // Initialize _lastValid for furniture reset functionality
    // This should be done after adding to canvas so final position is captured
    rect._lastValid = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        scaleX: rect.scaleX,
        scaleY: rect.scaleY,
        fill: rect.fill
    };

    return rect; // Return the created rectangle for further use
}

window.addTextBoxObject = function (box_size, word_color, text_val, x_location = "", y_location = "", width_size = "", height_size = "", locked = false, id = null) {
    if (id === null)
    {
        id = createId();
    }

    if(x_location === "")
    {
        x_location = box_size;
    }
    if(y_location === "")
    {
        y_location = box_size;
    }
    if(width_size === "")
    {
        width_size = box_size * 2;
    }
    if(height_size === "")
    {
        height_size = box_size * 2;
    }

    if(locked)
    {
        lock_move_x = true;
        lock_move_y = true;
        selectable = false;
    }else{
        lock_move_x = false;
        lock_move_y = false;
        selectable = true;
    }
    var new_text = new fabric.Textbox(text_val,{
        left: x_location,
        top: y_location,
        width: width_size,
        height: height_size,
        textAlign: 'center',
        fontSize: 20,
        fontFamily: 'Work Sans, serif',
        type: 'rectangle',
        fill: word_color,      //letter color
        backgroundColor: 'transparent',
        stroke:'',
        originX: 'left',
        originY: 'top',
        id: id,
        hasRotatingPoint: false,
        lockMovementX: lock_move_x,
        lockMovementY: lock_move_y,
        selectable: selectable,
    });
    canvas.add(new_text);
}

window.addTextBoxNumberingObject = function (text_value, left, top, width, height)
{
    var new_text = new fabric.Textbox(text_value, {
        left: left,
        top: top,
        width: width,
        height: height,
        textAlign: 'center',
        fontSize: 14,
        fontFamily: 'Work Sans, serif',
        type: 'rectangle',
        fill: 'black',      //letter color
        backgroundColor: 'transparent',
        stroke: '',
        originX: 'left',
        originY: 'top',
        selectable: false,          //this will stop them from being selectable, moveable or editable
        keep_object: true,          //custom object used to not clear them when using clear form button
    });
    canvas.add(new_text);
}

window.deleteList = function (listItems) {
    if(listItems !== undefined) {
        var len = listItems.length;
        var list = []
        for(var i = 0; i < len; i+= 1) {
            var item = listItems[i];
            //this keeps the outside numbering and lettering on clear
            if(item.keep_object)
            {
                continue;
            }
            //we don't want to remove the grid lines
            if (item.type !== "line") {
                list.push(item);
            }
        }
        len = list.length;
        for(var i = 0; i < len; i+= 1) {
            canvas.remove(list[i]);
        }
    }
}

window.copyHighlighted = function ()
{
    //this just copies the highlighted items into an array
    //we need to make sure that something is highlighted, if not, just drop out
    if(canvas.getActiveObject() === undefined)
    {
        return;
    }

    //reset array with copied objects
    copiedObjects = [];

    //Get the activeObject and the ActiveGroup
    var activeObject = canvas.getActiveObject(),
        activeGroup = canvas.getActiveGroup();

    //If multiple items are selected the activeGroups will be true
    if(activeGroup)
    {
        //get the objects from the activegroup
        var objectsInGroup = activeGroup.getObjects();

        //Discard the activeGroup
        canvas.discardActiveGroup();

        //Push all items from the activeGroup into our array
        objectsInGroup.forEach(function(object) {
            copiedObjects.push(object);
        });

    } else if (activeObject) {
        //discard that item so it won't show as active
        canvas.deactivateAll();
        //If one item is selected then activeObject will be true
        //push our selected item into the array
        copiedObjects.push(activeObject);
    }
    return copiedObjects;
}


window.pasteHighlighted = function (copiedObjects, box_size, paste_count, outside_height, outline_width, outside_width)
{
    //this pastes the highlighted items and also selects the highlighted items after
    //we need to make sure there is something to paste, checking if undefined did not work, just returned error so had to use typeof to get a string value
    if(typeof copiedObjects === 'undefined')
    {
        return;
    }

    //this will collect the cloned objects, so they can be selected
    var select_objects = new Array();
    if (copiedObjects.length > 1) {
        //run this if there is more than 1
        var count = 0;
        for (var index = (copiedObjects.length - 1); index >= 0; index--) {
            //send it off to be pasted
            //cloned_obj = pasteOneObject(copiedObjects[index].clone(), box_size, paste_count, outside_height);
            cloned_obj = pasteOneObject(copiedObjects[index].clone(), box_size, paste_count, outside_height, outline_width, outside_width);

            //get the cloned object back from the pasting, so we can use to select it
            //we do not want to set it as active below like we did as that will cause it to be resizable
            //select_objects.push(cloned_obj.set('active', true));

            count++;
        }
        //now that we have finished with all of them, send it over to be highlighted
        selectCopied(select_objects);
    }else{
        //Add our SINGLE item
        //cloned_obj = pasteOneObject(copiedObjects[0].clone(), box_size, paste_count, outside_height);
        cloned_obj = pasteOneObject(copiedObjects[0].clone(), box_size, paste_count, outside_height, outline_width, outside_width);
        //we do not want to set it as active below like we did as that will cause it to be resizable
        //select_objects.push(cloned_obj.set('active', true));

        //highlight/select that item
        selectCopied(select_objects);
    }
}

window.pasteOneObject = function (clone, box_size, paste_count, outside_height, outline_width, outside_width) {
    //set this, so we know if we should send the rectangle backwards so textbox always shows on top.
    send_backwards = false;

    clone.id = createId();

    switch(clone.type)
    {
        case 'circle':
            //we need to get the next available seat location to paste, we have to check and be sure that there is nothing where we are about to paste
            circle_location = getNextSeatLocationNew("paste", box_size, outline_width, outside_width, outside_height, clone, paste_count);

            //we do nothing for the left and just add the grid size to the top so, it moves down 1 - if it's a circle, it will add 1 to each below
            //clone.top += (box_size * paste_count);
            clone.top = circle_location['y_location'];
            //we need to make sure that it is not outside the parameters - the bottom edge
            if(clone.top > outside_height)
            {
                showErrMsg('The object can not be pasted, it is outside the layout');
                return null;
            }
            break;
        case 'rectangle':
            if(clone.text === undefined){
                //we need to get the next available seat location to paste, we have to check and be sure that there is nothing where we are about to paste
                //next_location = getNextFurnishingPasteLocation(clone, box_size, paste_count, outline_width, outside_width, outside_height);
                next_location = getNextFurnishingLocationNew("paste", box_size, outline_width, outside_width, outside_height,null, null, clone, paste_count);
                //we are going to use the current height of the box to set the next placement down
                //clone.top += (clone.height * paste_count);
                clone.top = next_location['y_location'];
                if((clone.top + clone.height) > (outside_height + outline_width))
                {
                    showErrMsg('The object can not be pasted, it is outside the layout');
                    return null;
                }
            }else{
                //since it is a text box, we are going to just put it 1 box down - we are not going to worry about anything under it.
                clone.top += (box_size * paste_count);
            }
            break;
        default:
            showErrMsg('Unknown object type.  Please try again');
    }

    clone.set('hasRotatingPoint', false);

    if(clone.type === "circle")
    {
        //we need to reset the height and width to the grid size for some reason it comes over wrong.
        //it actually comes over correct, but does not read correct. - CORRECTION, since sizing change it works right (leaving code though so can see later if needed)
        //clone.height = box_size;
        //clone.width = box_size;
        clone.set('hasControls', false);

        //we need to send the circle backwards as well or the textbox will not be in front of the rectangle
        send_backwards = true;
    }else{
        //the textbox and rect are both shown as rectangle, so we need to find out if this is a textbox
        if(clone.text === undefined)
        {
            send_backwards = true;
        }
    }

    clone.set('canvas', canvas);
    //Must call below when we changed our coordinates
    clone.setCoords();

    canvas.add(clone).renderAll();
    if(send_backwards){
        canvas.sendBackwards(clone);
    }

    return clone;
}



window.selectCopied = function (objs_set)
{
    // If any object in the group is a seat (circle or seat group), lock scaling for the group and for those objects
    var containsSeat = objs_set.some(function(obj) {
        // Check for circle (seat) or group with seat_id property (seat group)
        return obj.type === 'circle' || (obj.type === 'group' && obj.seat_id !== undefined);
    });
    var group = new fabric.Group(objs_set, {
        originX: 'left',
        originY: 'top',
        hasRotatingPoint: false,
        lockScalingX: containsSeat, // Lock scaling if any seat is present
        lockScalingY: containsSeat, // Lock scaling if any seat is present
    });
    // Also lock scaling on the seat objects themselves
    if (containsSeat) {
        objs_set.forEach(function(obj) {
            if (obj.type === 'circle' || (obj.type === 'group' && obj.seat_id !== undefined)) {
                obj.set('lockScalingX', true);
                obj.set('lockScalingY', true);
            }
        });
    }
    //make sure they don't have the thing on top that allows rotation
    group.setControlsVisibility({ mtr: false });
    //set the group as the new active group
    canvas.setActiveGroup(group.setCoords()).renderAll();
}

window.compute_grid_width_height_square = function (grid_width_qty, grid_height_qty, max_canvas_width)
{
    pass_vals = [];
    //we need to round everything so we have integers
    grid_sq_size = 0;
    if(grid_width_qty > grid_height_qty)
    {
        tmp_grid_sq_size = max_canvas_width / grid_width_qty;
        pass_vals['grid_sq_size'] = Math.ceil(tmp_grid_sq_size);
        //canvas width is easy, just number of rounded/ceil squares by width count
        pass_vals['new_canvas_width'] = pass_vals['grid_sq_size'] * grid_width_qty;

        pass_vals['new_canvas_height'] = pass_vals['grid_sq_size'] * grid_height_qty;
    }else{
        tmp_grid_sq_size = max_canvas_width / grid_height_qty;
        pass_vals['grid_sq_size'] = Math.ceil(tmp_grid_sq_size);
        pass_vals['new_canvas_height'] = pass_vals['grid_sq_size'] * grid_height_qty;
        pass_vals['new_canvas_width'] = pass_vals['grid_sq_size'] * grid_width_qty;
    }
    return pass_vals;
}

window.resizeGrid = function (old_grid_size_arr, new_grid_size_arr, old_grid_square_size, max_canvas_width, outline_width, seat_color, furniture_color, word_color)
{
    //first clear everything off the screen and reset the canvas so it can be re-sized
    // Remove all grid badges before clearing to prevent duplication
    var objects = canvas.getObjects();
    for (var i = objects.length - 1; i >= 0; i--) {
        if (objects[i]._isGridBadge) {
            canvas.remove(objects[i]);
        }
    }
    canvas.clear();
    canvas.dispose();

    //figure out what we are going to do with the width and height
    width_action = null;
    height_action = null;
    if(old_grid_size_arr['width'] !== new_grid_size_arr['width'])
    {
        if(new_grid_size_arr['width'] > old_grid_size_arr['width'])
        {
            //the new one is wider than the old one, so we will just center the current ones
            width_action = "center";
        }else{
            //this is less wide (and may squish things), we are going to center it and make sure nothing is on top of each other
            width_action = "center_and_check";
        }
    }else{
        //we are going to do nothing with the existing x_location
        width_action = "same";
    }
    if(old_grid_size_arr['height'] !== new_grid_size_arr['height'])
    {
        if(new_grid_size_arr['height'] > old_grid_size_arr['height'])
        {
            //the new one is taller than the old one, so we will not move anything up or down
            height_action = "same";
        }else{
            //this is shorter, we are going to leave them in the same place as this should be built top down
            //we will do the check after to make sure nothing is on top of each other or outside the canvas
            height_action = "same_and_check";
        }
    }else{
        //we are going to do nothing with the existing x_location
        height_action = "same";
    }

    new_grid_width = new_grid_size_arr['width'];
    new_grid_height = new_grid_size_arr['height'];

    width_vals = compute_grid_width_height_square(new_grid_width, new_grid_height, max_canvas_width);
    canvas_width = width_vals['new_canvas_width'];
    canvas_height = width_vals['new_canvas_height'];
    new_grid_sq_size = width_vals['grid_sq_size'];

    //recreate the canvas size
    canvas = new fabric.Canvas('floor-plan-canvas', { selection: true, selectionKey: "ctrlKey" });
    canvas.setWidth(canvas_width + outline_width);
    canvas.setHeight(canvas_height + outline_width);

    //rebuild the lines to the new size
    createGridLines(canvas, max_canvas_width, new_grid_sq_size, outline_width, canvas_width, canvas_height);


    //now we need to rebuild the size of the existing objects, get our size multipliers
    grid_move_multiplier = old_grid_square_size / new_grid_sq_size;
    grid_square_multiplier = new_grid_sq_size / old_grid_square_size;
    old_grid_size = new_grid_sq_size * grid_square_multiplier;

    layouts.forEach((layout) => {
        switch(layout['item_type']){
            case "circle":
                old_grid_number_x = (layout['x_location'] - outline_width) / old_grid_square_size;
                //first we get the left location or x_location
                switch(width_action)
                {
                    case "same":
                        //even if the width did not change, the square size could as the height could be larger or smaller
                        //we need to get the old location in blocks and then multiply that by the new number of blocks over
                        //x_location = layout['x_location'] * grid_square_multiplier;
                        x_location = (old_grid_number_x * new_grid_sq_size) + outline_width;
                        break;
                    case "center":
                    case "center_and_check":
                        //this will re-center the seats, we use the multiplier to find their new location
                        //if center and check (got smaller), we will do the check after creating all the things on the canvas

                        //we need to center things - get the old # of squares wide by new # wide and create a ratio to do that
                        //any that are outside will have the check run anyway that makes sure they are not put on top of each other or go outside the canvas
                        size_difference = 0;
                        if(new_grid_size_arr['width'] > old_grid_size_arr['width'])
                        {
                            size_difference = Math.floor((new_grid_size_arr['width'] - old_grid_size_arr['width']) / 2);
                        }
                        x_location = ((old_grid_number_x * new_grid_sq_size) + (size_difference * new_grid_sq_size) + outline_width) - 1;
                        break;
                }
                switch(height_action) {
                    case "same":
                    case "same_and_check":
                        //even if the height did not change, the square size could as the width could be larger or smaller
                        //we need to get the old location in blocks and then multiply that by the new number of blocks over
                        old_grid_number_y = ((layout['y_location']-1) - outline_width) / old_grid_square_size;
                        y_location = ((old_grid_number_y * new_grid_sq_size) + outline_width);
                        break;
                }
                //let it know not loaded from dbase
                addSeatObject(false, x_location, y_location, new_grid_sq_size, seat_color, false, layout['seat_id']);
                break;
            case "rectangle":
                //find out if this is a furnishing or a label - both are rectangles, but label has item_text
                if(isEmpty(layout['item_text']))
                {
                    switch(width_action) {
                        case "same":
                            old_grid_number_x = (layout['x_location'] - outline_width) / old_grid_square_size;
                            x_location = (old_grid_number_x * new_grid_sq_size) + outline_width;
                            break;
                        case "center":
                        case "center_and_check":
                            x_location = layout['x_location'];
                            y_location = layout['y_location'];

                            old_grid_number_x = (layout['x_location'] - outline_width) / old_grid_square_size;
                            //since the width has changed, try to center it.
                            size_difference = Math.floor((new_grid_size_arr['width'] - old_grid_size_arr['width']) / 2);

                            x_location = (old_grid_number_x * new_grid_sq_size) + (size_difference * new_grid_sq_size) + outline_width;
                            //we need to get the new y_location based on the grid in case it resized
                            old_grid_number_y= (layout['y_location'] - outline_width) / old_grid_square_size;
                            y_location = (old_grid_number_y * new_grid_sq_size) + outline_width;

                            //if the furnishing is too far left, it may try to place it outside, fix it that it will be at first position
                            if(x_location < outline_width)
                            {
                                x_location = outline_width;
                            }

                            //we also need to check and make sure that they don't go out the right side either
                            //we will take the x_location and add the width of the rectangle to it.  if that is > canvas_width + outline_width
                            //move it over, the center and check will fix if there is overlap

                            //if the far left edge is outside the canvas, just let it be, the check for on top or outside will take care of it
                            // Check if furnishing extends beyond the right edge of the canvas
                            if ((x_location + layout['width']) > (canvas_width + outline_width)) {
                                // Adjust position so furnishing fits within canvas bounds
                                x_location = (canvas_width + outline_width) - layout['width'];
                            }

                            // Ensure furnishing doesn't start outside the left edge
                            if (x_location < outline_width) {
                                x_location = outline_width;
                            }
                            break;
                    }
                    switch(height_action) {
                        case "same":
                        case "same_and_check":
                            old_grid_number_y = ((layout['y_location']) - outline_width) / old_grid_square_size;
                            y_location = ((old_grid_number_y * new_grid_sq_size) + outline_width);
                            break;
                    }

                    //we need to calculate the new width and height in case the box size changed
                    old_width_box_ct = layout['width'] / old_grid_square_size;
                    new_width = old_width_box_ct * new_grid_sq_size;
                    old_heigh_box_ct = layout['height'] / old_grid_square_size;
                    new_height = old_heigh_box_ct * new_grid_sq_size;
                    //make sure knows not loaded from dbase
                    addStructureObject(new_grid_sq_size, furniture_color, x_location, y_location, new_width, new_height, false, layout['seat_id']);

                }else{

                    //the difference between the label and furnishing is that the label does not need to be locked to grid.
                    switch(width_action) {
                        case "same":
                            old_grid_number_x = (layout['x_location'] - outline_width) / old_grid_square_size;
                            new_x_location = (old_grid_number_x * new_grid_sq_size) + outline_width;
                            break;
                        case "center":
                        case "center_and_check":
                            old_grid_number_x = (layout['x_location'] - outline_width) / old_grid_square_size;
                            size_difference = Math.floor((new_grid_size_arr['width'] - old_grid_size_arr['width']) / 2);
                            new_x_location = (old_grid_number_x * new_grid_sq_size) + (size_difference * new_grid_sq_size) + outline_width;
                            //if the label is too far left, it may try to place it outside, fix it that it will be at first position
                            if(new_x_location < outline_width)
                            {
                                new_x_location = outline_width;
                            }
                            //we also need to check and make sure that they don't go out the right side either
                            //we will take the x_location and add the width of the rectangle to it.  if that is > canvas_width + outline_width
                            //move it over, the center and check will fix if there is overlap
                            if((new_x_location + layout['width']) > (canvas_width + outline_width))
                            {
                                //make the starting location the right side minus the width of the furnishing
                                new_x_location = (canvas_width + outline_width) - layout['width'];
                            }
                            break;
                    }
                    switch(height_action) {
                        case "same":
                        case "same_and_check":
                            old_grid_number_y = (layout['y_location'] - outline_width) / old_grid_square_size;
                            new_y_location = (old_grid_number_y * new_grid_sq_size) + outline_width;
                            //old_grid_number_y = ((layout['y_location']-1) - outline_width) / old_grid_square_size;
                            //y_location = ((old_grid_number_y * new_grid_sq_size) + outline_width);
                            break;
                    }
                    addTextBoxObject(new_grid_sq_size, word_color, layout['item_text'], new_x_location, new_y_location, layout['width'], layout['height'], false, layout['seat_id']);
                }
        }
    });

    if(width_action === "center_and_check" || height_action === "same_and_check")
    {
        //we are going to see if any are on top of another, if so, we will move the ones on top of each other.
        //we will do them as if add new from the button, start on left and move them over until open space
        //we will move down a line if that line is full.
        //we also need to check for any that got moved outside the canvas
        //first get the grid width and height to see if outside
        ck_grid_width = canvas_width + outline_width;
        ck_grid_height = canvas_height + outline_width;

        //we need to get the current objects in the canvas - just the circles and rectangles
        //start with the circles
        cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
        ct=1;
        for(var key in cirObjects) {
            if (cirObjects.hasOwnProperty(key)) {
                //check to see if any outside the grid, if so, move them inside the grid
                if(cirObjects[key].left >= ck_grid_width)
                {
                    grid_width_px = grid_width * new_grid_sq_size;
                    grid_height_px = grid_height * new_grid_sq_size;

                    //get the next location to drop it - we check to see if anything is in that spot or if outside the canvas
                    next_location = getNextSeatLocationNew("resize", new_grid_sq_size, outline_width, grid_width_px, grid_height_px, null, null, cirObjects[key].top);

                    //we will now move it to the new location
                    cirObjects[key].left = next_location['x_location'];
                    cirObjects[key].top = next_location['y_location'];
                    //re-render it so that they show up and can be used when checking for new seat location, and so we don't put 1 on top of it.
                    //first setCoords so it can be selected where it sits
                    cirObjects[key].setCoords();
                    canvas.renderAll();
                }
            }
            //if there is a circle outside the grid, we will want to move it up the grid so it is there.
            if(cirObjects[key].top >= ck_grid_height)
            {

                //we may be able to do this in the "getNextSeatLocationNew" function if we work on it a bit
            }
        }

        //now we do the furnishings and the labels
        rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);
        for(var key in rectObjects) {

            if (rectObjects.hasOwnProperty(key)) {
                //we only check it if there is no text - text indicates text box, and we are not going to worry about those
                //text boxes can sit over top other things, and it does not matter, so we ignore them.
                if(rectObjects[key].text === undefined)
                {
                    //do the rectangles - we need to just make sure it is not sitting on something else or outside the grid
                    //we keep it inside the lines on a move.
                    grid_width_px = grid_width * new_grid_sq_size;
                    grid_height_px = grid_height * new_grid_sq_size;
                    location['x_location'] = rectObjects[key].left;
                    location['y_location'] = rectObjects[key].top;

                    do {
                        location = resizeFurnishingCheckOnTop(rectObjects[key], location, new_grid_sq_size, outline_width, grid_width_px, grid_height_px);
                    }
                    while (location['check_move'] === true);

                    //we will now move it to the new location
                    rectObjects[key].left = location['x_location'];
                    rectObjects[key].top = location['y_location'];
                    //re-render it so that they show up and can be used when checking for new seat location, and so we don't put 1 on top of it.
                    //first setCoords so it can be selected where it sits
                    rectObjects[key].setCoords();
                    canvas.renderAll();
                }
            }
        }
    }

    //////ThIS RESETS the box_size in the kiosk-seating-layout page so that when we add an object OR copy/paste, it will use the right grid size
    resize_box_size = new_grid_sq_size;

    // Update global box_size variable for grid snapping
    if (typeof box_size !== 'undefined') {
        box_size = new_grid_sq_size;
    }

    //now re-render the canvas
    canvas.renderAll();

    ///WE NEED TO RESET THE OBJECT TOOLS ON A RESIZE - they quit working and we also need to reset the box size so they do the
    //right snap to grid.
    //this will keep the rotating point from showing up when selecting multiple items
    canvas.on('selection:created', function (e) {
        const activeSelection = e.target
        activeSelection.set({hasRotatingPoint: false})
    })

    //this is used to get starting location if they are doing a drag and drop and go outside the canvas
    canvas.on('mouse:down', function (e) {
        activeSelection = e.target;
        //make sure it is not null, such as clicking on the canvas or nowhere or it throws java error and messes up mouse actions
        if(activeSelection !== null)
        {
            start_left = activeSelection.left;
            start_top = activeSelection.top;
            start_width = activeSelection.width;
            start_height = activeSelection.height;
        }
    })

    move_info = [];
    this_location = [];
    //set the initial info for move info
    reset_move_info();

    // Event handlers are now handled by the main layout file to avoid conflicts
// snap to grid function - just when something is moved
    canvas.on('object:moving', function(options) {
        //check to see if there is text, if there is, do not snap to grid as it will be registered as modified and do the work there
        //this also removes the moving of the rectangle - this covers furnishing and label textbox
        new_left = Math.round((options.target.left - outline_width) / box_size) * box_size + outline_width;
        new_top = Math.round((options.target.top - outline_width) / box_size) * box_size + outline_width;

        grid_width_px = grid_width * new_grid_sq_size;
        grid_height_px = grid_height * new_grid_sq_size;

        if(options.target.type === 'rectangle')
        {
            //we need to see if a rectangle has been dropped outside
            is_outside = checkDropOutside("rectangle", start_left, start_top, new_top, new_left, grid_height_px, grid_width_px, outline_width, options.target.width, options.target.height);
            if (is_outside !== null) {
                new_left = is_outside['start_left'];
                new_top = is_outside['start_top'];
                options.target.set({
                    left: new_left,
                    top: new_top
                });
            }
            //if this is a label box, we need to drop out or, it will be snapped to grid below
            if((typeof options.target.text !== 'undefined'))
            {
                return;
            }
        }

        //at this point, there is only circles
        //WE MUST add 1 to the snap to grid location left and top as the circle is 2px smaller than the box,
        //and we need the 1 on each side of it

        if(options.target.type === 'circle' || options.target.type === 'group') {
            //we need to make sure it is not outside the edges when they drop it, if so, move back to origin
            is_outside = checkDropOutside("circle", start_left, start_top, new_top, new_left, grid_height_px, grid_width_px, outline_width);
            if (is_outside !== null) {
                new_left = is_outside['start_left'];
                new_top = is_outside['start_top'];
            }

            //add 1 to the object, so it is centered in the box - it snaps to grid but does not add 1 to it.
            new_left +=1;
            new_top +=1;

        }

        //set the new location
        options.target.set({
            left: new_left,
            top: new_top
        });
    });


    //this resizes the altar and snaps to grid when anything is resized or moved
    //ignore when it is textbox as it is not supposed to snap to grid.
    //also ignore circle as it is done in the moving
    canvas.on('object:modified', function(options) {
        //CIRCLE NOT DONE HERE - this is resizing of rectangle only
        //check to see if there is text, if there is, do not snap to grid
        //we also do not need to do the circle as it is not resizable
        if ((options.target.type !== 'rectangle') || (typeof options.target.text !== 'undefined'))
        {
            return;
        }

        // Define minimum size (one grid cell)
        var minSize = box_size;

        // Get current dimensions
        var currentWidth = options.target.getScaledWidth();
        var currentHeight = options.target.getScaledHeight();

        // Store original position
        var originalLeft = options.target.left;
        var originalTop = options.target.top;

        // Calculate new dimensions with grid snapping
        var newWidth = (Math.round(currentWidth / box_size)) * box_size;
        var newHeight = (Math.round(currentHeight / box_size)) * box_size;

        // Clamp to minimum size
        if (newWidth < minSize) {
            newWidth = minSize;
        }
        if (newHeight < minSize) {
            newHeight = minSize;
        }

        // Calculate new position with grid snapping
        var newLeft = Math.round((originalLeft - outline_width) / box_size) * box_size + outline_width;
        var newTop = Math.round((originalTop - outline_width) / box_size) * box_size + outline_width;

        // Always maintain the original position to prevent movement
        options.target.set({
            width: newWidth,
            height: newHeight,
            scaleX: 1,
            scaleY: 1,
            left: originalLeft,
            top: originalTop
        });
    });

    // Add scaling event handler to ensure minimum size clamping works properly
    canvas.on('object:scaling', function(options) {
        // Only handle rectangle furnishings (not textboxes or circles)
        if ((options.target.type !== 'rectangle') || (typeof options.target.text !== 'undefined')) {
            return;
        }

        // Define minimum size (one grid cell)
        var minSize = box_size;

        // Get current scaled dimensions
        var currentWidth = options.target.getScaledWidth();
        var currentHeight = options.target.getScaledHeight();

        // If either dimension is below minimum, clamp it
        if (currentWidth < minSize || currentHeight < minSize) {
            // Calculate the minimum scale factors needed
            var minScaleX = minSize / options.target.width;
            var minScaleY = minSize / options.target.height;

            // Use the larger scale factor to maintain aspect ratio if needed
            var finalScaleX = Math.max(options.target.scaleX, minScaleX);
            var finalScaleY = Math.max(options.target.scaleY, minScaleY);

            // Apply the clamped scaling
            options.target.set({
                scaleX: finalScaleX,
                scaleY: finalScaleY
            });
        }
    });
}

window.resizeFurnishingCheckOnTop = function (passedObject, location, new_grid_sq_size, outline_width, grid_width, grid_height)
{
    //we need to get all the info about the top/bottom and left/right of this box
    //we need the ID of this box, so we can skip checking it below in the rectangle check
    furnishing_id = passedObject['id'];
    furnishing_top = location['y_location'];
    furnishing_bottom = location['y_location'] + passedObject['height'];
    furnishing_left = location['x_location'];
    furnishing_right = location['x_location'] + passedObject['width'];

    //first we will make sure it is not on top of a circle
    cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
    for(var key in cirObjects) {
        if (cirObjects.hasOwnProperty(key)) {
            check_height = false;
            check_width = false;

            //we need to get the center of the circle and use that to test against
            object_top = cirObjects[key].top + (cirObjects[key].height / 2);
            object_left = cirObjects[key].left + (cirObjects[key].width / 2);

            if(furnishing_top < object_top && furnishing_bottom > object_top)
            {
                check_height = true;
            }
            if(furnishing_left < object_left && furnishing_right > object_left)
            {
                check_width = true;
            }

            if(check_height && check_width)
            {
                location['check_move'] = true;
                location['x_location'] = location['x_location'] + new_grid_sq_size;
                location['y_location'] = location['y_location'];

                //we need to make sure that the move did not push it outside the right of the canvas
                //if so, we need to add the height of the rectangle to the y_location and start it at position 1
                if((location['x_location'] + passedObject['width']) > (grid_width + outline_width))
                {
                    location['x_location'] = outline_width;
                    location['y_location'] = location['y_location'] + new_grid_sq_size;
                }
                return location;
            }
        }
    }
    //now we will make sure that they are not on top of another rectangle.
    rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);
    for(var key in rectObjects) {
        if (rectObjects.hasOwnProperty(key)) {
            //we only check it if there is no text - text indicates text box, and we are not going to worry about those
            if (rectObjects[key].text === undefined) {
                //next we make sure that this is not the same one we are working on, we use the ID
                if(rectObjects[key].id !== passedObject['id'])
                {
                    existing_left = rectObjects[key].left;
                    existing_right = rectObjects[key].left + rectObjects[key].width;
                    existing_top = rectObjects[key].top;
                    existing_bottom = rectObjects[key].top + rectObjects[key].height;

                    //we will check to make sure this rectangle is not on top of another
                    //reset the flags for checking inside the box
                    check_width = false;
                    check_height = false;

                    //we do not add 1 to these as the furniture goes to edge of box
                    left_border = rectObjects[key].left;
                    right_border = rectObjects[key].left + rectObjects[key].width;
                    top_border = rectObjects[key].top;
                    bottom_border = rectObjects[key].top + rectObjects[key].height;

                    //we also need to make sure it did not push it outside the bottom of the canvas
                    if((location['y_location'] + passedObject['height']) > (grid_height + outline_width)) {
                        //we need to calculate the y position

                        location['y_location'] = 980;
                        location['check_move'] = false;
                        return location;
                    }else{
                        if (left_border <= location['x_location'] && right_border > location['x_location'] && top_border <= location['y_location'] && bottom_border > location['y_location']) {
                            location['check_move'] = true;
                            location['x_location'] = location['x_location'] + new_grid_sq_size;
                            location['y_location'] = location['y_location'];

                            //check and make sure it did not put the right border outside the canvas
                            if ((location['x_location'] + passedObject['width'] + new_grid_sq_size) > (grid_width + outline_width)) {
                                //we need to move down a line and start left at position 1
                                location['x_location'] = outline_width;
                                location['y_location'] = location['y_location'] + new_grid_sq_size;
                            }

                            return location;
                        }
                    }
                }
            }
        }
    }

    location['check_move'] = false;

    return location;
}

window.getNextSeatLocationNew = function (location_type, box_size, outline_width, outside_width, outside_height, clone = null, paste_count = null, y_start_location = null)
{
    //location_type = add,paste,resize
    //x_location = left
    //y_location = top
    var location = [];
    //set the default locations
    //we will ONLY use outline width on default location of 0,0 or box A1
    location['x_location'] = outline_width + 1;
    location['y_location'] = outline_width + 1;

    switch(location_type){
        case "add":
            //get the active object and test it.
            actObj = canvas.getActiveObject('circle');
            if(actObj !== null && actObj !== undefined)
            {
                //only set the location if the object is highlighted, AND it is a circle
                //subtract one from each one as the object will already have that space added to it
                if(actObj.type === "circle"){
                    location['x_location'] = actObj.left + box_size - 1;
                    location['y_location'] = actObj.top - 1;
                }
            }
            break;
        case "paste":
            //set the default locations - stay with the current left and use the original starting point of the one copied
            //then add the box size times number of copies already made to drop it 1 each paste.
            new_top = clone.top + (box_size * paste_count);

            //set the default location
            location['x_location'] = clone.left;
            location['y_location'] = new_top;
            break;
        case "resize":
            //we are going to use the starting point of the line to move over
            location['y_location'] = y_start_location;
            break;
        default:
            return null;
    }

    //now we are going to make sure there is nothing in the location which we want this to appear in.
    //it will return the new location to put it in
    //we need to loop multiple times as we need to check until there is nothing in the way
    do {
        location = checkForObjectInLocation(location_type, location, box_size, outline_width, outside_width);
    }
    while (location['check_move'] === true);
    if(location_type === "add")
    {
        //make sure that the seat is not outside the bottom of the box - if so return null, it will be taken care of in calling function
        if(location['y_location'] > outside_height)
        {
            return null;
        }
    }

    return location;
}

window.checkForObjectInLocation = function (check_type, location, box_size, outline_width = null, outside_width = null)
{
    //check_type = add or paste
    //x_location = left
    //y_location = top

    //we are going to check here and make sure it is not outside the layout box, if so, we are going to drop down 1 row and
    //place it in the A column - it will get checked below to see if anything is in its place
    //set the value to know if we need to do this loop again
    location['check_move'] = false;

    if(check_type === "add")
    {
        if(location['x_location'] > outside_width)
        {
            location['y_location'] =  location['y_location'] + box_size;
            location['x_location'] =  outline_width;
        }
    }

    //this gets all circles as these should be seats - we will check those first
    cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
    for(var key in cirObjects) {
        if (cirObjects.hasOwnProperty(key)) {
            tmp_x_location = location['x_location'];
            tmp_y_location = location['y_location'];

            if(check_type === "add"){
                //add the 1 to the location - it is not currently there, but will be if added
                tmp_x_location += 1;
                tmp_y_location += 1;
            }

            if(check_type === "resize") {
                //if this is a resize, we need to see if something in the spot we are looking to put it in - if so, return this location
                //the loop in getNextSeatLocationNew will keep it going as long as check_move not true
                if (cirObjects[key].left === tmp_x_location && cirObjects[key].top === tmp_y_location) {
                    location['check_move'] = true;
                    location['x_location'] = location['x_location'] + box_size;
                    return location;
                }
                //now we see if it is outside the width of the canvas.  if it is, we push it down 1 row and re-start at column 1
                if(tmp_x_location > outside_width)
                {
                    location['check_move'] = true;
                    location['x_location'] = outline_width + 1;
                    location['y_location'] = location['y_location'] + box_size;
                    return location;
                }
            }else {
                if (cirObjects[key].left === tmp_x_location && cirObjects[key].top === tmp_y_location) {
                    location['check_move'] = true;
                    if (check_type === "add") {
                        location['x_location'] = location['x_location'] + box_size;
                    }
                    if (check_type === "paste") {
                        location['y_location'] = location['y_location'] + box_size;
                    }
                    return location;
                }
            }
        }
    }

    //next we check furnishings - this gets the furnishings and furnishing labels
    //(not numbering around edges - those are not selectable).
    // could not use 'text' as it is not defined for furnishings, we need to ignore the labels from this
    rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);
    for(var key in rectObjects) {
        if (rectObjects.hasOwnProperty(key)) {
            //we only check it if there is no text - text indicates text box, and we are not going to worry about those
            if(rectObjects[key].text === undefined)
            {
                //we do not add 1 to these as the furniture goes to edge of box
                left_border = rectObjects[key].left
                right_border = rectObjects[key].left + rectObjects[key].width;
                top_border = rectObjects[key].top;
                bottom_border = rectObjects[key].top + rectObjects[key].height;

                if(check_type === "resize") {
                    if (left_border <= location['x_location'] && right_border > location['x_location'] && top_border <= location['y_location'] && bottom_border > location['y_location']) {
                        location['check_move'] = true;
                        location['x_location'] = location['x_location'] + box_size;
                        return location;
                    }
                    //now we see if it is outside the width of the canvas.  if it is, we push it down 1 row and re-start at column 1
                    if(left_border > outside_width)
                    {
                        location['check_move'] = true;
                        location['x_location'] = outline_width + 1;
                        location['y_location'] = location['y_location'] + box_size;
                        return location;
                    }
                }else {
                    //if the seat falls between any of the above, we will move it 1 right
                    if (left_border <= location['x_location'] && right_border > location['x_location'] && top_border <= location['y_location'] && bottom_border > location['y_location']) {
                        location['check_move'] = true;
                        if (check_type === "add") {
                            location['x_location'] = right_border;
                        }
                        if (check_type === "paste") {
                            location['y_location'] = bottom_border + 1;
                        }
                        return location;
                    }
                }
            }
        }
    }

    //if they got through all the checks, return the value back out to make the seat
    return location;
}

window.objectInLocationEventChange = function (new_location, start_location_info, box_size, furniture_color)
{
    //we are going to see if there is anything where they did drag drop or resize.  This will let it drop where they
    //set it if nothing there, otherwise it will return it to the starting place
    //if a resize, it will resize back to original size and location if they stretched it over an existing object
    //we will also return true or false so that a message can be shown if moved back
    //we need the box size and color passed in.  It's passed in case the rectangle covers something on resize
    //IF this is a circle (new_location['move_type']), we need to make sure if in the box - a circle is too small to hit the center of the box

    //x_location = left
    //y_location = top

    //get the type of furniture being moved as we need to treat a circle differently than furnishings
    //a circle goes inside another box.  A rectangle can cover a circle, so it's edges would be outside the circle
    move_furniture_type = new_location['move_type']

    //get the locations of the piece's drop location
    furnishing_left = new_location['x_location'];
    furnishing_right = new_location['x_location'] + new_location['width'];
    furnishing_top = new_location['y_location'];
    furnishing_bottom = new_location['y_location'] + new_location['height'];



    //get the circle and rectangle objects in the canvas
    cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
    rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);

    if(move_furniture_type === "circle") {
        //get all canvas object, we do them 1 at a time, circle and then rectangle, otherwise we get lines also
        //this gets all circles as these should be seats - we will check those first
        for (var key in cirObjects) {
            if (cirObjects.hasOwnProperty(key)) {
                //this will skip the one that is being moved
                if (cirObjects[key].id === new_location['id']) {
                    continue;
                }
                //reset the flags for checking inside the circle
                check_width = false;
                check_height = false;

                existing_left = cirObjects[key].left;
                existing_right = cirObjects[key].left + cirObjects[key].width;
                existing_top = cirObjects[key].top;
                existing_bottom = cirObjects[key].top + cirObjects[key].height;

                //make sure it is not between the left and right or between top and bottom
                if (furnishing_left >= existing_left && furnishing_right <= existing_right) {
                    check_width = true;
                }
                if (furnishing_top >= existing_top && furnishing_bottom <= existing_bottom) {
                    check_height = true;
                }

                //this will check and make sure there is nothing in the square that this should be put in
                if (check_height && check_width) {
                    resetLocationToStartPoint(start_location_info, box_size, furniture_color);
                    return false;
                }
            }
        }


        //next we check furnishings/rectangles - this gets the furnishings and furnishing labels
        //(not numbering around edges - those are not selectable).
        // could not use 'text' as it is not defined for furnishings, we need to ignore the labels from this
        for (var key in rectObjects) {
            if (rectObjects.hasOwnProperty(key)) {
                //we only check it if there is no text - text indicates text box, and we are not going to worry about those
                if (rectObjects[key].text !== undefined) {
                    continue;
                }
                //this will skip the one that is being moved
                if (rectObjects[key].id === new_location['id']) {
                    continue;
                }

                //reset the flags for checking inside the box
                check_width = false;
                check_height = false;

                existing_left = rectObjects[key].left;
                existing_right = rectObjects[key].left + rectObjects[key].width;
                existing_top = rectObjects[key].top;
                existing_bottom = rectObjects[key].top + rectObjects[key].height;

                //make sure it is not between the left and right or between top and bottom
                if (furnishing_left > existing_left && furnishing_right < existing_right) {
                    check_width = true;
                }
                if (furnishing_top > existing_top && furnishing_bottom < existing_bottom) {
                    check_height = true;
                }

                //this will check and make sure there is nothing in the square that this should be put in
                if (check_height && check_width) {
                    resetLocationToStartPoint(start_location_info, box_size, furniture_color);
                    return false;
                }
            }
        }
    }else{
        //since we are moving a rectangle, we need to see if something under it.
        for (var key in cirObjects) {
            if (cirObjects.hasOwnProperty(key)) {
                //this will skip the one that is being moved
                if (cirObjects[key].id === new_location['id']) {
                    continue;
                }

                //reset the flags for checking over a circle
                check_width = false;
                check_height = false;

                //get the location of an existing circle
                existing_left = cirObjects[key].left;
                existing_right = cirObjects[key].left + cirObjects[key].width;
                existing_top = cirObjects[key].top;
                existing_bottom = cirObjects[key].top + cirObjects[key].height;

                //make sure it is not over the left and right or over top and bottom
                if(existing_left > furnishing_left && existing_right < furnishing_right)
                {
                    check_width = true;
                }
                if(existing_top > furnishing_top && existing_bottom < furnishing_bottom)
                {
                    check_height = true;
                }

                //this will check and make sure there is nothing in the square that this is being dropped in
                if (check_height && check_width) {
                    resetLocationToStartPoint(start_location_info, box_size, furniture_color);
                    return false;
                }
            }
        }

        for (var key in rectObjects) {
            //here we need to make sure that no part of the moved ractangle covers any part of an existing rectangle
            if (rectObjects.hasOwnProperty(key)) {
                //we only check it if there is no text - text indicates text box, and we are not going to worry about those
                if (rectObjects[key].text !== undefined) {
                    continue;
                }
                if (rectObjects[key].id === new_location['id']) {
                    continue;
                }

                // Account for furniture margin in collision detection
                var FURNITURE_MARGIN = 3;
                existing_left = rectObjects[key].left;
                existing_right = rectObjects[key].left + rectObjects[key].width;
                existing_top = rectObjects[key].top;
                existing_bottom = rectObjects[key].top + rectObjects[key].height;

                //first we need to see if it is totally inside the box
                //use the equal as well as when snapped to grid will be the same edge measurements
                if(existing_left <= furnishing_left && existing_right >= furnishing_right && existing_top <= furnishing_top && existing_bottom >= furnishing_bottom)
                {
                    resetLocationToStartPoint(start_location_info, box_size, furniture_color);
                    return false;
                }

                // Check for actual overlap using bounding box collision detection
                // Account for furniture margin to prevent overlaps
                var hasOverlap = !(
                    furnishing_right <= existing_left ||
                    furnishing_left >= existing_right ||
                    furnishing_bottom <= existing_top ||
                    furnishing_top >= existing_bottom
                );

                if (hasOverlap) {
                    resetLocationToStartPoint(start_location_info, box_size, furniture_color);
                    return false;
                }
            }
        }
    }
    return true;
}

window.resetLocationToStartPoint = function (reset_location, box_size, furniture_color)
{
    //get the active object and group, it will still be active after re-size or drop
    var activeObject = canvas.getActiveObject(),
        activeGroup = canvas.getActiveGroup();

    //If multiple items are selected the activeGroup will be true
    if(activeGroup)
    {
        //get the objects from the activegroup
        var objectsInGroup = activeGroup.getObjects();

        //we have the group, now unselect it
        canvas.discardActiveGroup();

        //reset each item in the group to the start point
        objectsInGroup.forEach(function(object) {
            if(object !== null && (object.type === 'rectangle' || object.type === 'circle')) {
                if(object.type === "rectangle")
                {
                    //if it is a rectangle, it will not reset to a smaller size, so we have to delete it and re-make it
                    temp_id = object.id;
                    // Preserve the original color from _lastValid if available, otherwise use current fill
                    var original_color = (object._lastValid && object._lastValid.fill) ? object._lastValid.fill : object.fill;
                    canvas.remove(object);
                    addStructureObject(box_size, original_color, reset_location['x_location'], reset_location['y_location'], reset_location['width'], reset_location['height'], false, temp_id);

                    // Apply consistent furniture alignment if the callback is available
                    if (typeof window.applyFurnitureAlignment === 'function') {
                        window.applyFurnitureAlignment(temp_id);
                    }
                }else{
                    object.set('left', reset_location['x_location']);
                    object.set('top', reset_location['y_location']);
                    object.setCoords();
                }
            }
        });
        canvas.renderAll();
    }else if(activeObject){
        //handle single object selection
        if(activeObject.type === "rectangle")
        {
            //if it is a rectangle, it will not reset to a smaller size, so we have to delete it and re-make it
            temp_id = activeObject.id;
            // Preserve the original color from _lastValid if available, otherwise use current fill
            var original_color = (activeObject._lastValid && activeObject._lastValid.fill) ? activeObject._lastValid.fill : activeObject.fill;
            canvas.remove(activeObject);
            addStructureObject(box_size, original_color, reset_location['x_location'], reset_location['y_location'], reset_location['width'], reset_location['height'], false, temp_id);

            // Apply consistent furniture alignment if the callback is available
            if (typeof window.applyFurnitureAlignment === 'function') {
                window.applyFurnitureAlignment(temp_id);
            }
        }else{
            activeObject.set('left', reset_location['x_location']);
            activeObject.set('top', reset_location['y_location']);
            activeObject.setCoords();
            canvas.renderAll();
        }
    }

}

window.getNextFurnishingLocationNew = function (new_type, box_size, outline_width, canvas_width, canvas_height, furnishing_width = null, furnishing_height = null, clone = null, paste_count = null)
{
    //new_type = add or paste
    //x_location = left
    //y_location = top
    //set the default locations
    var location = [];

    if(new_type === "add") {
        location['x_location'] = outline_width;
        location['y_location'] = outline_width;

        //get the active object and test it to be sure it is a furnishing and not a label, if so use this as the starting location
        actObj = canvas.getActiveObject('rectangle');

        if(actObj !== null && actObj !== undefined)
        {
            //only set the location if the object is highlighted, AND it is a circle
            //subtract one from each one as the object will already have that space added to it
            if(actObj.type === "rectangle" && actObj.text === undefined){
                location['x_location'] = actObj.left + box_size;
                location['y_location'] = actObj.top;
            }
        }
    }

    if(new_type === "paste"){
        new_top = clone.top + (clone.height * paste_count);
        furnishing_width = clone.width;
        furnishing_height = clone.height;
        location['x_location'] = clone.left;
        location['y_location'] = new_top;
    }

    // Try the exact calculated position first
    var exactLocation = { x_location: location['x_location'], y_location: location['y_location'] };

    // Check bounds for the exact position
    if (exactLocation.x_location >= outline_width && exactLocation.y_location >= outline_width &&
        (exactLocation.x_location + furnishing_width) <= canvas_width &&
        (exactLocation.y_location + furnishing_height) <= canvas_height) {

        // Test if this location is clear
        var testLocation = { x_location: exactLocation.x_location, y_location: exactLocation.y_location };
        var testResult = structureCheckForObjectInLocation(new_type, testLocation, box_size, outline_width, canvas_width, canvas_height, furnishing_width, furnishing_height);
        if (!testResult.check_move) {
            location = testResult;
        } else {
            // If exact position fails, try fallback alignments relative to the calculated location
            // These fallbacks anchor the furniture's different corners to the calculated location

            // Fallback 1: Anchor furniture's bottom-right to calculated location
            var fallback1X = exactLocation.x_location - furnishing_width;
            var fallback1Y = exactLocation.y_location - furnishing_height;
            if (fallback1X >= outline_width && fallback1Y >= outline_width) {
                var testLocation1 = { x_location: fallback1X, y_location: fallback1Y };
                var testResult1 = structureCheckForObjectInLocation(new_type, testLocation1, box_size, outline_width, canvas_width, canvas_height, furnishing_width, furnishing_height);
                if (!testResult1.check_move) {
                    location = testResult1;
                }
            }

            // Fallback 2: Anchor furniture's bottom-left to calculated location
            var fallback2X = exactLocation.x_location;
            var fallback2Y = exactLocation.y_location - furnishing_height;
            if (fallback2Y >= outline_width) {
                var testLocation2 = { x_location: fallback2X, y_location: fallback2Y };
                var testResult2 = structureCheckForObjectInLocation(new_type, testLocation2, box_size, outline_width, canvas_width, canvas_height, furnishing_width, furnishing_height);
                if (!testResult2.check_move) {
                    location = testResult2;
                }
            }

            // Fallback 3: Anchor furniture's top-right to calculated location
            var fallback3X = exactLocation.x_location - furnishing_width;
            var fallback3Y = exactLocation.y_location;
            if (fallback3X >= outline_width) {
                var testLocation3 = { x_location: fallback3X, y_location: fallback3Y };
                var testResult3 = structureCheckForObjectInLocation(new_type, testLocation3, box_size, outline_width, canvas_width, canvas_height, furnishing_width, furnishing_height);
                if (!testResult3.check_move) {
                    location = testResult3;
                }
            }
        }
    }

    // If no fallback position found, use the original logic
    if (location['x_location'] === outline_width && location['y_location'] === outline_width) {
        //now we are going to make sure there is nothing in the location which we want this to appear in.
        //it will return the new location to put it in
        //we need to loop multiple times as we need to check until there is nothing in the way
        do {
            location = structureCheckForObjectInLocation(new_type, location, box_size, outline_width, canvas_width, canvas_height, furnishing_width, furnishing_height);
        }
        while (location['check_move'] === true);
    }

    if(new_type === "add") {
        if((location['y_location'] + furnishing_height) > (outside_height + outline_width))
        {
            return null;
        }
    }

    return location;
}

window.structureCheckForObjectInLocation = function (add_type, location, box_size, outline_width, canvas_width, canvas_height, structure_width, structure_height){
    //x_location = left
    //y_location = top
    //add_type = add or paste

    //we need to find out if where we drop it if there will be anything under it, if so move it 1 to the right
    //if we are at the end of the line, move it to the next line
    //set the check to re-run to default of false
    location['check_move'] = false;

    if(add_type === "add")
    {
        //we need to see if the paste would be too far left, if so, we need to move down the height of the structure
        if((location['x_location'] + structure_width) > (canvas_width + outline_width))
        {
            location['y_location'] =  location['y_location'] + structure_height;
            location['x_location'] =  outline_width;
        }
    }

    //get the locations of the piece of the furnishing proposed drop location
    furnishing_top = location['y_location'];
    furnishing_bottom = location['y_location'] + structure_height;
    furnishing_left = location['x_location'];
    furnishing_right = location['x_location'] + structure_width;

    //get all canvas object, we do them 1 at a time, circle and then rectangle, otherwise we get lines also
    //this gets all circles as these should be seats - we will check those first
    cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
    for(var key in cirObjects) {
        if (cirObjects.hasOwnProperty(key)) {
            check_height = false;
            check_width = false;

            //we need to get the center of the circle and use that to test against
            object_top = cirObjects[key].top + (cirObjects[key].height / 2);
            object_left = cirObjects[key].left + (cirObjects[key].width / 2);

            if(furnishing_top < object_top && furnishing_bottom > object_top)
            {
                check_height = true;
            }
            if(furnishing_left < object_left && furnishing_right > object_left)
            {
                check_width = true;
            }
            //this will check and make sure there is nothing in the square that this should be put in
            if(check_height && check_width)
            {
                location['check_move'] = true;
                if(add_type === "add"){
                    //if there is something there, we will move it 1 box to the right.
                    location['x_location'] = location['x_location'] + box_size;
                }
                if(add_type === "paste") {
                    //if there is something there, we will move it 1 box down.
                    location['y_location'] = location['y_location'] + box_size;
                }
                return location;
            }
        }
    }


    //next we check furnishings/rectangles - this gets the furnishings and furnishing labels
    //(not numbering around edges - those are not selectable).
    // could not use 'text' as it is not defined for furnishings, we need to ignore the labels from this
    rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);
    for(var key in rectObjects) {
        if (rectObjects.hasOwnProperty(key)) {
            //we only check it if there is no text - text indicates text box, and we are not going to worry about those
            if(rectObjects[key].text === undefined) {
                //we need to check if the box being dropped is totally inside another box
                inside_box = false;
                //we need to check if the box being dropped is totally covering another box
                cover_the_box = false;
                //we need to check if the box being dropped is partially covering another box (a side AND a (top or bottom) are inside another box)
                part_cover_box = false;


                //we need to get the center of the rectangle and use that to test against
                //object_y_center_top = rectObjects[key].top + (rectObjects[key].height / 2);
                //object_x_center_left =  + (rectObjects[key].width / 2);
                object_left = rectObjects[key].left;
                object_right = rectObjects[key].left + rectObjects[key].width;
                object_top = rectObjects[key].top;
                object_bottom = rectObjects[key].top + rectObjects[key].height;

                //this checks if the box would be inside another (or covering it) - both statements need to be true
                check_top = false;
                check_bottom = false;
                check_left = false;
                check_right = false;
                //see if the furnishing top and bottom are on the line or inside the object line
                //ck the top
                if(furnishing_top >= object_top && furnishing_top <= object_bottom)
                {
                    check_top = true;
                }
                //ck the bottom
                if(furnishing_bottom >= object_top && furnishing_bottom <= object_bottom)
                {
                    check_bottom = true;
                }
                //see if the furnishing left and right are on the line or inside the object line
                //ck the left
                if(furnishing_left >= object_left && furnishing_left <= object_right)
                {
                    check_left = true;
                }
                //ck the right
                if(furnishing_right >= object_left && furnishing_right <= object_right)
                {
                    check_right = true;
                }

                //if both are true, it is inside the box
                if(check_top && check_bottom && check_left && check_right){
                    inside_box = true;
                }

                //we need to check if the box would totally cover another
                check_height = false;
                check_width = false;
                //see if the furnishing top and bottom are bigger than the object - we do not check equal as inside the box will do that
                if(furnishing_top < object_top && furnishing_bottom > object_bottom)
                {
                    check_height = true;
                }
                //see if the furnishing left and right are bigger than the object - we do not check equal as inside the box will do that
                if(furnishing_left < object_left && furnishing_right > object_right)
                {
                    check_width = true;
                }
                if(check_height && check_width){
                    cover_the_box = true;
                }

                //we need to check if a furnishing is partially over another
                //check_height = false;
                //check_width = false;
                check_top = false;
                check_bottom = false;
                check_left = false;
                check_right = false;

                //if 1 of the furnishing top or bottom lines is inside the object - we do not check equal as they can share a border
                // - side by side or top and bottom, etc.
                //first we check the top
                if(furnishing_top > object_top && furnishing_top < object_bottom)
                {
                    //check_height = true;
                    check_top = true;
                }
                //now check the bottom line
                if(furnishing_bottom > object_top && furnishing_bottom < object_bottom)
                {
                    //check_height = true;
                    check_bottom = true;
                }
                //check the left line
                if(furnishing_left > object_left && furnishing_left < object_right)
                {
                    //check_width = true;
                    check_left = true;
                }
                //check the right line
                if(furnishing_right > object_left && furnishing_right < object_right)
                {
                    //check_width = true;
                    check_right = true;
                }
                //if(check_height && check_width){
                if(check_top && check_bottom && check_left && check_right){
                    part_cover_box = true;
                }


                //this will check and make sure there is nothing in the square that this should be put in
                if(part_cover_box || cover_the_box || inside_box){
                    location['check_move'] = true;
                    if(add_type === "add") {
                        //if there is something there, we will move it 1 box to the right.
                        location['x_location'] = location['x_location'] + box_size;
                    }
                    if(add_type === "paste") {
                        //if there is something there, we will move it 1 box down.
                        location['y_location'] = location['y_location'] + box_size;
                    }

                    return location;
                }
            }
        }
    }
    return location;
}

window.checkDropOutside = function (object_type, start_left, start_top, new_top, new_left, canvas_height, canvas_width, outline_width, rectangle_width = null, rectangle_height = null)
{
    //check to be sure that the object is not dropped outside the canvas
    var location = [];

    if(object_type === "circle")
    {
        if(new_top > canvas_height || new_top < outline_width || new_left < outline_width || new_left > canvas_width){
            showErrMsg('The seat can not be moved outside the layout.  It has been moved back to where you started');
            //move it back to the starting locations, remove 1 from it as a regular move adds 1 to it.  this uses the current size
            location['start_left'] = start_left - 1;
            location['start_top'] = start_top - 1;
            return location;
        }
    }
    if(object_type === "rectangle")
    {
        if(new_top < outline_width || (new_top + rectangle_height) > (canvas_height + outline_width) || new_left < outline_width || (new_left + rectangle_width) > (canvas_width + outline_width))
        {
            showErrMsg('The furnishing or label can not be moved outside the layout.  It has been moved back to where you started');
            location['start_left'] = start_left;
            location['start_top'] = start_top;
            return location;
        }
    }
    return null;
}

// Global grid alignment functions for consistent seat and furniture positioning
// These functions ensure all views render seats and furniture with the same grid alignment

window.applySeatGridAlignment = function (obj, targetLeft, targetTop) {
    if (typeof targetLeft === 'undefined') targetLeft = obj.left;
    if (typeof targetTop === 'undefined') targetTop = obj.top;
    var w = (obj.width * (obj.scaleX || 1)) || (typeof box_size !== 'undefined' ? box_size : 50);
    var h = (obj.height * (obj.scaleY || 1)) || w;

    var snappedLeft, snappedTop, seatRadius;
    if (typeof getGridCoordinatesFromPixel === 'function' && typeof getSeatPixelFromGrid === 'function' &&
        window.gridPositioning && window.gridPositioning.boxSize) {
        var coords = getGridCoordinatesFromPixel(targetLeft, targetTop, w, h);
        var pixel = getSeatPixelFromGrid(coords.gridX, coords.gridY);
        snappedLeft = pixel.left;
        snappedTop = pixel.top;
        seatRadius = pixel.radius;
    } else {
        var headerCellSize = 40;
        var centerX = targetLeft + w / 2;
        var centerY = targetTop + h / 2;
        var gridX = Math.round((centerX - headerCellSize - box_size / 2) / box_size);
        var gridY = Math.round((centerY - headerCellSize - box_size / 2) / box_size);
        var maxGridWidth = typeof grid_width !== 'undefined' ? grid_width : 999;
        var maxGridHeight = typeof grid_height !== 'undefined' ? grid_height : 999;
        gridX = Math.max(0, Math.min(gridX, maxGridWidth - 1));
        gridY = Math.max(0, Math.min(gridY, maxGridHeight - 1));
        var seatMargin = 2;
        seatRadius = (box_size / 2) - seatMargin;
        snappedLeft = headerCellSize + (gridX * box_size) + (box_size / 2) - seatRadius;
        snappedTop = headerCellSize + (gridY * box_size) + (box_size / 2) - seatRadius;
    }

    obj.set({ left: snappedLeft, top: snappedTop, radius: seatRadius });
    return { left: snappedLeft, top: snappedTop, radius: seatRadius };
}

// Centralized function for consistent furniture sizing and positioning
window.applyFurnitureGridAlignment = function (obj, targetLeft, targetTop, targetWidth, targetHeight) {
    var FURNITURE_MARGIN = 3; // px, consistent margin
    var headerCellSize = 40; // Consistent header cell size;

    // If no target dimensions provided, use current object dimensions
    if (typeof targetLeft === 'undefined') targetLeft = obj.left;
    if (typeof targetTop === 'undefined') targetTop = obj.top;
    if (typeof targetWidth === 'undefined') targetWidth = obj.width * (obj.scaleX || 1);
    if (typeof targetHeight === 'undefined') targetHeight = obj.height * (obj.scaleY || 1);

    // Calculate grid cell position with exact alignment
    // Use headerCellSize consistently instead of outline_width
    var gridX = Math.round((targetLeft - headerCellSize) / box_size);
    var gridY = Math.round((targetTop - headerCellSize) / box_size);

    // Ensure grid coordinates are within bounds - use global variables if available
    var maxGridWidth = typeof grid_width !== 'undefined' ? grid_width : 999;
    var maxGridHeight = typeof grid_height !== 'undefined' ? grid_height : 999;
    gridX = Math.max(0, Math.min(gridX, maxGridWidth - 1));
    gridY = Math.max(0, Math.min(gridY, maxGridHeight - 1));

    // Calculate exact pixel position for perfect grid alignment
    var snappedLeft = headerCellSize + (gridX * box_size) + FURNITURE_MARGIN/2;
    var snappedTop = headerCellSize + (gridY * box_size) + FURNITURE_MARGIN/2;

    // Calculate width/height in grid cells and snap to grid
    var widthCells = Math.max(1, Math.round(targetWidth / box_size));
    var heightCells = Math.max(1, Math.round(targetHeight / box_size));

    // Ensure furniture doesn't extend beyond grid boundaries
    // Only adjust if the furniture would be completely outside the grid
    if (gridX < 0) {
        gridX = 0;
    }
    if (gridY < 0) {
        gridY = 0;
    }
    // Don't resize furniture that extends beyond grid - just clamp position
    if (gridX + widthCells > maxGridWidth) {
        gridX = maxGridWidth - widthCells;
        if (gridX < 0) gridX = 0; // If still too wide, start from edge
    }
    if (gridY + heightCells > maxGridHeight) {
        gridY = maxGridHeight - heightCells;
        if (gridY < 0) gridY = 0; // If still too tall, start from edge
    }

    // Calculate exact dimensions based on grid cells
    var snappedWidth = (widthCells * box_size) - FURNITURE_MARGIN;
    var snappedHeight = (heightCells * box_size) - FURNITURE_MARGIN;

    // Ensure minimum size
    if(snappedWidth < box_size - FURNITURE_MARGIN) snappedWidth = box_size - FURNITURE_MARGIN;
    if(snappedHeight < box_size - FURNITURE_MARGIN) snappedHeight = box_size - FURNITURE_MARGIN;

    // Apply the aligned properties to the object
    obj.set({
        left: snappedLeft,
        top: snappedTop,
        width: snappedWidth,
        height: snappedHeight,
        scaleX: 1,
        scaleY: 1
    });

    // Update _lastValid if it exists
    if (obj._lastValid) {
        obj._lastValid.left = obj.left;
    obj._lastValid.top = obj.top;
    obj._lastValid.width = obj.width;
    obj._lastValid.height = obj.height;
    obj._lastValid.scaleX = obj.scaleX;
    obj._lastValid.scaleY = obj.scaleY;
    obj._lastValid.fill = obj.fill;
    }

    return {
        left: snappedLeft,
        top: snappedTop,
        width: snappedWidth,
        height: snappedHeight
    };
}

// Helper function to create optimized seat labels with consistent sizing and positioning
window.createOptimizedSeatLabel = function (personName, boxSize, radiusSize) {
    // Split name into first and last name for better layout
    var nameParts = personName.trim().split(' ');
    var firstName = nameParts[0] || '';
    var lastName = nameParts.slice(1).join(' ') || '';

    // Calculate the center position of the seat for proper text alignment (relative to group)
    // Since the circle is positioned at radius_size from the left/top edges of the group,
    // the center of the circle is at radius_size from the group's left/top
    var seatCenterX = radiusSize;
    var seatCenterY = radiusSize;

    // Calculate available space within the circle (accounting for circle shape)
    var circleRadius = radiusSize;
    var availableWidth = circleRadius * 1.8; // Increased for better text fit
    var availableHeight = circleRadius * 1.6; // Increased for better text fit

    // Create text content - try to put first and last name on separate lines
    var textContent = '';
    if (firstName && lastName) {
        textContent = firstName + '\n' + lastName;
    } else {
        textContent = personName;
    }

    // Calculate a consistent font size that will work for all seats
    // Use a smaller, more conservative approach to ensure text always fits
    var consistentFontSize = Math.max(8, Math.floor(boxSize * 0.12));

    var text = new fabric.Textbox(textContent, {
        fontFamily: 'Work Sans, serif',
        textAlign: 'center',
        width: availableWidth,
        height: availableHeight,
        originX: 'center',
        originY: 'center',
        left: seatCenterX,
        top: seatCenterY,
        fixedWidth: availableWidth,
        fontSize: consistentFontSize, // Use consistent font size for all seats
        wordWrap: 'break-word',
        splitByGrapheme: true,
        fill: '#2c3e50', // Darker text for better contrast
        fontWeight: '600',
        lineHeight: 1.1, // Slightly increased line spacing for better readability
        selectable: false,
        evented: false
    });

    // Ensure text always fits by scaling down if necessary
    // This maintains the same font size across all seats while ensuring fit
    if (text.width > availableWidth || text.height > availableHeight) {
        var scaleX = availableWidth / text.width;
        var scaleY = availableHeight / text.height;
        var scale = Math.min(scaleX, scaleY, 1); // Don't scale up, only down

        text.set({
            fontSize: consistentFontSize * scale,
            width: availableWidth,
            height: availableHeight
        });
    }

    return text;
}

// Helper function to detect and adjust for overlapping labels
window.adjustTextForOverlap = function (text, seatX, seatY, boxSize) {
    if (!window.canvas) return text;

    // Get all existing seat groups to check for overlaps
    var existingSeats = window.canvas.getObjects('group').filter(function(obj) {
        return obj.personName && obj !== text; // Exclude the current text being created
    });

    // Check for overlaps with adjacent seats
    var hasOverlap = false;
    var headerCellSize = 40;

    // Calculate grid position of current seat
    var currentGridX = Math.round((seatX - headerCellSize) / boxSize);
    var currentGridY = Math.round((seatY - headerCellSize) / boxSize);

    // Check adjacent seats (up, down, left, right)
    var adjacentPositions = [
        {x: currentGridX - 1, y: currentGridY}, // left
        {x: currentGridX + 1, y: currentGridY}, // right
        {x: currentGridX, y: currentGridY - 1}, // up
        {x: currentGridX, y: currentGridY + 1}  // down
    ];

    for (var i = 0; i < adjacentPositions.length; i++) {
        var pos = adjacentPositions[i];
        var adjacentSeat = existingSeats.find(function(seat) {
            var seatGridX = Math.round((seat.left - headerCellSize) / boxSize);
            var seatGridY = Math.round((seat.top - headerCellSize) / boxSize);
            return seatGridX === pos.x && seatGridY === pos.y;
        });

        if (adjacentSeat) {
            // Instead of reducing font size, we'll let the text wrapping and scaling handle overlap
            // This maintains consistent font sizes across all seats
            hasOverlap = true;
            break;
        }
    }

    // Remove the logic that forces initials for crowded rows - let fabric.js handle text wrapping
    // The text will automatically wrap and scale as needed

    return text;
}


// Function to clean up canvas and global variables before navigation
window.cleanupCanvasBeforeNavigation = function () {
    try {
        // Disable CSS transitions to prevent shaking during navigation
        $('#memberSidebarCol, #seatingChartCol').css('transition', 'none');

        // Clean up canvas if it exists
        if (typeof canvas !== 'undefined' && canvas) {
            if (canvas.clear) {
                canvas.clear();
            }
            if (canvas.dispose) {
                canvas.dispose();
            }
            canvas = null;
        }

        // Clear global variables that might conflict
        if (typeof window.canvas !== 'undefined') {
            window.canvas = null;
        }
        if (typeof window.box_size !== 'undefined') {
            delete window.box_size;
        }
        if (typeof window.grid_width !== 'undefined') {
            delete window.grid_width;
        }
        if (typeof window.grid_height !== 'undefined') {
            delete window.grid_height;
        }

        // Clear any pending assignments and removals
        if (typeof window.pendingAssignments !== 'undefined') {
            window.pendingAssignments = [];
        }
        if (typeof window.pendingRemovals !== 'undefined') {
            window.pendingRemovals = [];
        }

        // Clear drag and drop state
        if (typeof isDragging !== 'undefined') {
            isDragging = false;
        }
    } catch (error) {
        console.warn('Error during canvas cleanup:', error);
    }
}

window.roundTo2DecimalPlaces = (val) => Number(val.toFixed(2));

/* Bootstrap modal body cleanup (also in functions.js for manager/member shells). */
(function initSeatingBootstrapModalBodyCleanup() {
    if (typeof window.initBootstrapModalBodyCleanup === 'function') {
        window.initBootstrapModalBodyCleanup();
        return;
    }
    function cleanupBootstrapModalBody() {
        if (!$ || $('.modal.show').length > 0) {
            return;
        }
        $('body').removeClass('modal-open').css({ paddingRight: '', overflow: '' });
        $('.modal-backdrop').remove();
    }
    $(function () {
        $(document).on('hidden.bs.modal', '.modal', cleanupBootstrapModalBody);
        if ($.fn.modal && !$.fn.modal.__bodyCleanupPatched) {
            const bsModal = $.fn.modal;
            $.fn.modal = function (option, ...rest) {
                const result = bsModal.apply(this, arguments);
                if (option === 'hide') {
                    setTimeout(cleanupBootstrapModalBody, 0);
                }
                return result;
            };
            $.fn.modal.__bodyCleanupPatched = true;
        }
    });
    window.cleanupBootstrapModalBody = cleanupBootstrapModalBody;
})();
